export default "__VITE_ASSET__8ZiKZueG__"